import { actionTypes } from "../contants/actionTypes";

const initialState = {
    isLoading: true,
    dataDocumentToSign: []
}

export const signDocumentReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.isLoadingDataSignatureDoc:
            return {
                ...state,
                isLoading: action.payload,
            }
        case actionTypes.loadDataSignatureDoc:
            return {
                ...state,
                dataDocumentToSign: action.payload,
            }
        default:
            return state;
    }
}